import React from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"

import ContentView from "scenes/Customer/components/ContentView"
import Typograph from "components/Typograph"

import styles from "./styles.css"

const AudioContent = ({
  fileAudioURL,
  audio,
  audioBase64,
  loading,
  error,
  t,
  classNames
}) => {
  if (!fileAudioURL && !audio) return null

  const hasAudioWithoutUrl = audio && !fileAudioURL
  if (hasAudioWithoutUrl) {
    return (
      <Typograph htmlTag="p" size="small" color="pumping_spice" weight="bold">
        {t("AUDIO_NOT_AVALIABLE")}
      </Typograph>
    )
  }

  return (
    <ContentView classNames={classNames}>
      <Typograph
        htmlTag="span"
        size="small"
        color="outer_space"
        weight="regular"
      >
        {`${t("MSG_0400")}:`}
      </Typograph>
      {loading && (
        <Typograph
          htmlTag="p"
          size="small"
          color="outer_space"
          weight="regular"
        >
          {t("MSG_0484")}
        </Typograph>
      )}
      {error && (
        <Typograph
          htmlTag="p"
          size="small"
          color="outer_space"
          weight="regular"
        >
          {t("MSG_0485")}
        </Typograph>
      )}
      {!loading && audioBase64 && (
        <audio className={styles.audio} controls controlsList="nodownload">
          <source src={audioBase64} type="audio/mp3"></source>
          {t("BROWSER_NOT_SUPPORT_AUDIO")}
        </audio>
      )}
    </ContentView>
  )
}

AudioContent.propTypes = {
  fileAudioURL: PropTypes.string,
  audio: PropTypes.string,
  audioBase64: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  classNames: PropTypes.string,
  t: PropTypes.func
}

const enhance = compose(translate())

export default enhance(AudioContent)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/RequestTrackingModal/AudioContent.js